import * as types from '@/store/mutation-types'
import axios from 'axios'

const state = {
  appDrawer: null,
  showNewUpdateMessage: false,
  newUpdate: {
    text: '',
    secondary: false,
    showReloadButton: false,
    timeout: 0,
    onClick: () => {}
  },
  pushNotificationEnabled: false
}

const mutations = {
  [types.DRAWER]: (state, payload) => {
    state.appDrawer = payload
  },
  [types.DRAWER_TOGGLE]: (state) => {
    state.appDrawer = !state.appDrawer
  },

  [types.NEW_UPDATE]: (state, payload) => {
    state.showNewUpdateMessage = true
    state.newUpdate = payload
  },

  [types.PUSH_NOTIFICATION]: (state, payload) => {
    console.log(types.PUSH_NOTIFICATION)
    console.log(payload)
    state.pushNotificationEnabled = payload
  }
}

const getters = {
  getBaseURL: () => {
    return process.env.BASE_URL
  },
  isPushEnabled: state => state.pushNotificationEnabled
}

const actions = {
  [types.NEW_UPDATE] ({commit}, message) {
    commit(types.NEW_UPDATE, message)
  },
  [types.PUSH_NOTIFICATION_UNSUBSCRIBE] ({commit}) {
    navigator.serviceWorker.ready.then(registration => {
      registration.pushManager.getSubscription().then(subscription => {
        if (!subscription) {
          commit(types.PUSH_NOTIFICATION, false)
          return
        }
        subscription.unsubscribe().then(() => {
          axios.post('/alumno/subscriptions/delete', { endpoint: subscription.endpoint })
          commit(types.PUSH_NOTIFICATION, false)
        }).catch(e => {
          console.log('Unsubscription error: ', e)
        })
      }).catch(e => {
        console.log('Error thrown while unsubscribing.', e)
      })
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js